export default ($stateProvider) => {
  $stateProvider
    .state('wrapper.chat-list', {
      url: 'chat-list',
      template: '<nets-chat-sms></nets-chat-sms>',
    });
};
